
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9bGZv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f0a5c8fb30cf5cdf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $f0a5c8fb30cf5cdf$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': 'Reactie toevoegen',
    'fabric.reactions.error.unexpected': 'Reacties zijn tijdelijk niet beschikbaar',
    'fabric.reactions.loading': "Bezig met laden\u2026",
    'fabric.reactions.more.emojis': "Meer emoji's",
    'fabric.reactions.other.reacted.users': "{count, plural, one {en \xe9\xe9n andere} other {en {count} andere}}",
    'fabric.reactions.reactwithemoji': 'Reageren met emoticon {emoji}',
    'fabric.reactions.summary': 'Alle reacties van gebruikers bekijken',
    'reaction-picker-trigger.add.reaction.message': 'Voeg een reactie toe',
    'reactions.dialog.close': 'Sluiten',
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': 'Navigeer naar links',
    'reactions.dialog.reactions.count': '{count, plural, one {{count,number} totale reactie} other {{count,number} totale reacties}}',
    'reactions.dialog.right.navigate': 'Navigeer naar rechts',
    'reactions.dialog.viewall': 'Alles bekijken',
    'reactions.dialog.viewall.tooltip': 'Alle reacties van gebruikers bekijken'
};

});


//# sourceMappingURL=nl.fca31f49.js.map
